// extracted by mini-css-extract-plugin
module.exports = {"container":"J-vp","title":"RP0G"};